function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { mutate, OneClickFeedbackMutation } from "@custom/schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
var formValueSchema = z.object({
    url: z.string().url('Please fill in the full profile URL, for example "https://www.linkedin.com/in/your-profile/".').regex(new RegExp("http(s)?://([w]+.)?linkedin.com/in/[A-z0-9_-]+/?", ""), 'Please fill in the full profile URL, for example "https://www.linkedin.com/in/your-profile/".')
});
export function LinkedInFeedbackForm() {
    var _result, _formState_errors_url, _result1, _result2, _result3;
    var _useForm = useForm({
        resolver: zodResolver(formValueSchema),
        values: {
            url: ""
        },
        mode: "onSubmit"
    }), register = _useForm.register, handleSubmit = _useForm.handleSubmit, formState = _useForm.formState;
    var _useState = _sliced_to_array(useState(null), 2), result = _useState[0], setResult = _useState[1];
    var onSubmit = function(values) {
        mutate("/graphql", OneClickFeedbackMutation, {
            input: {
                url: values.url,
                referrer: window.location.href
            }
        }).then(function(result) {
            if (!result.data.oneClickFeedback.success) {
                setResult({
                    success: false,
                    message: result.data.oneClickFeedback.message
                });
            } else {
                setResult(result.data.oneClickFeedback);
            }
            return null;
        }).catch(function(e) {
            console.error(e);
            setResult({
                success: false,
                message: "Something went wrong, please try again."
            });
        });
    };
    var _formState_errors_url_message;
    return /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "my-4 flex flex-col gap-2"
    }, /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, (formState.errors.url || !!result && !((_result = result) === null || _result === void 0 ? void 0 : _result.success)) && /*#__PURE__*/ React.createElement(motion.div, {
        className: "flex bg-red-500 rounded-md items-center justify-center",
        initial: "hidden",
        animate: "visible",
        exit: "hidden",
        variants: {
            hidden: {
                height: 0,
                opacity: 0
            },
            visible: {
                height: "auto",
                opacity: 1
            }
        },
        transition: {
            duration: 0.5,
            ease: "easeInOut"
        }
    }, /*#__PURE__*/ React.createElement("p", {
        className: "m-0 text-white text-lg leading-lg px-6 py-3",
        "data-testid": "error-message",
        "aria-label": "Error message"
    }, (_formState_errors_url_message = (_formState_errors_url = formState.errors.url) === null || _formState_errors_url === void 0 ? void 0 : _formState_errors_url.message) !== null && _formState_errors_url_message !== void 0 ? _formState_errors_url_message : (_result1 = result) === null || _result1 === void 0 ? void 0 : _result1.message))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col md:flex-row gap-2 p-4 border border-green-100 rounded-md flex-1 text-green-500 text-sm leading-xs font-semibold uppercase items-center shadow-md"
    }, ((_result2 = result) === null || _result2 === void 0 ? void 0 : _result2.success) ? /*#__PURE__*/ React.createElement("p", {
        className: "m-0 px-6 text-green-500 normal-case font-sans font-normal",
        "data-testid": "success-message",
        "aria-label": "Success message"
    }, result.message) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("label", {
        className: "me-2 whitespace-nowrap",
        htmlFor: "urlInput"
    }, "One Click Feedback"), /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({}, register("url")), {
        id: "urlInput",
        className: "w-full focus-white px-4 py-2.5 placeholder:italic placeholder:font-thin text-black font-sans font-normal border border-green-100 rounded-md",
        placeholder: "https://www.linkedin.com/in/your-profile/"
    })), /*#__PURE__*/ React.createElement("button", {
        type: "submit",
        className: "px-4 py-[0.6875rem] bg-green-500 button-primary"
    }, "Send"))), !((_result3 = result) === null || _result3 === void 0 ? void 0 : _result3.success) && /*#__PURE__*/ React.createElement("p", {
        className: "text-sm leading-sm m-0 text-gray-700 italic self-start"
    }, "A member of our Talent Acquisition team will respond soon"));
}
